import { settingsRoutes, settingsNavigationItems } from "./router";
/**
 * Settings Module - provides profile settings and notifications
 *
 * This module demonstrates the modular architecture pattern:
 * - Routes are defined in router/index.ts (separation of concerns)
 * - Module registration logic is in index.ts
 * - Components are in presentation/ directory
 */
export class SettingsModule {
    constructor() {
        Object.defineProperty(this, "contracts", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: null
        });
    }
    register(contracts) {
        this.contracts = contracts;
        contracts.logger.debug("[SettingsModule] Registered");
        return {
            id: "settings",
            name: "Settings Module",
            version: "1.0.0",
        };
    }
    getRoutes() {
        // Import routes from dedicated router file for better structure
        return settingsRoutes;
    }
    getNavigationItems() {
        // Import navigation items from dedicated file for better structure
        return settingsNavigationItems;
    }
    getComponent() {
        return null;
    }
    unregister() {
        this.contracts?.logger.debug("[SettingsModule] Unregistered");
        this.contracts = null;
    }
}
export default new SettingsModule();
